import {API} from '../../Services';
import Platform from 'react-platform-js';
import sha256 from "sha256"
// import FingerprintJS from '@fingerprintjs/fingerprintjs'

// const fpPromise = FingerprintJS.load()
//
// const getFinger = async ()=>{
//     const fp = await fpPromise
//     const result = await fp.get()
//
//     // This is the visitor identifier:
//     const visitorId = result.visitorId
//     console.log("finger : ",visitorId)
//     return  visitorId
// }

//
// async function CheckFcm() {
//     const token = localStorage.getItem('token');
//     // console.log("Device : ", Platform.UA)
//     return API.get(`/users/fcm-submits`, {
//         headers: {
//             'Authorization': `Bearer ${token}`,
//             'User-Agent': Platform.UA
//         }
//     });
// }
//
//
// async function SetFcm(reqObj){
//     const token = localStorage.getItem('token');
//     // console.log("Device : ", Platform.UA)
//     return API.post(`/users/fcm-submits`,reqObj,{ headers: {
//         'Authorization':  `Bearer ${token}`,
//         'User-Agent': Platform.UA
//     } });
// }



async function CheckFcm() {
    let user = localStorage.getItem('user');
    let parsed_user = JSON.parse(user);
    let uid = parsed_user.uid;
    let fingerId = sha256(window.navigator.userAgent)
    return API.get(`/users/${uid}/clients/${fingerId}`);
}


async function SetFcm(reqObj){
    let user = localStorage.getItem('user');
    let parsed_user = JSON.parse(user);
    let uid = parsed_user.uid;
    let fingerId = sha256(window.navigator.userAgent)
    return API.put(`/users/${uid}/clients/${fingerId}`,reqObj);
}

export {CheckFcm,SetFcm};
